module.exports = __webpack_public_path__ + "assets/8b2560200f88ac169ed34fe5ad74f274.mp3";